import { defineNuxtPlugin } from '#app';

const QA_BUSINESS_HOST = 'business-qa.toogoodtogo.com';

export default defineNuxtPlugin(() => {
  const { public: { feedbucket } } = useRuntimeConfig();

  if (window.location.hostname !== QA_BUSINESS_HOST || !feedbucket.projectId) {
    return;
  }

  useHead({
    script: [
      {
        id: 'FeedBucket',
        src: 'https://cdn.feedbucket.app/assets/feedbucket.js',
        crossorigin: 'anonymous',
        defer: true,
        // @ts-expect-error
        module: true,
        'data-feedbucket': feedbucket.projectId,
      },
    ],
  });
});
